import { FC, useEffect, useState } from 'react';
import { IFloatMiniEntrance } from 'base/interfacesV2/feature';
import { getFloatMiniEntrance } from 'base/servicesV2/feature';
import FixedContainer from '@base/lib/FixedContainer';
import Image from '@base/lib/ThemeImage';
import Iconfont from '@base/lib/Iconfont';
import { observer, useStore, useStoreState } from 'base/store';
import cn from 'classnames';

import styles from './index.module.less';
import Tracker from '@base/lib/Tracker';
import { getModuleCode } from 'base/utils/features';
import { FixedItem, StateType } from 'base/store/popupFixedStore'

const cookieKey = 'FloatMiniEntrance';

type IProps = {
    className?: string;
};

const FloatMiniEntrance: FC<IProps> = ({ className }) => {
    const [data, setData] = useState<IFloatMiniEntrance | undefined>();
    const { pageCode, pageLoading } = useStoreState('rootStore');

    const { popupFixedStore } = useStore();

    let isStoreShow = false;
    if (popupFixedStore.state) {
        // console.log('FloatMiniEntrance', JSON.parse(JSON.stringify(popupFixedStore.state)));
        const isShow = popupFixedStore.checkDisPlayInOrder(StateType.Fixed, FixedItem.defaultFixed, 'true')
        isStoreShow = isShow || false;
    }

    const {
        page = [],
        redirectLink,
        resourceLink,
        windowHeight = 50,
        windowWidth = 50,
    } = data || {};

    const handleClose = () => {
        sessionStorage.setItem(cookieKey, '1');
        setData(void 0)
    };

    const init = async () => {
        try {
            const res = await getFloatMiniEntrance();
            if (res && res.resourceLink) {
                setData(res);
            }

        } catch (e) {
        }
    };

    useEffect(() => {
        if (!sessionStorage.getItem(cookieKey)) {
            init();
        }
    }, []);

    return !isStoreShow || (!data || !page.includes(pageCode as string) || pageLoading)
        ? null
        : (
            <FixedContainer
                offset={process.env.NEXT_PUBLIC_TERMINAL === 'm' ? [0, 0] : [10, 10]}
                width="auto"
                className={cn(className, styles['float-mini-entrance'])}
                zIndex={303}
            >
                <Tracker
                    async
                    data={{
                        module: getModuleCode({ moduleId: 'Float popup' }),
                        targetType: 'popup',
                        target: resourceLink as string,
                        relTarget: resourceLink,
                        position: 1,
                    }}
                >
                    <Image
                        href={!redirectLink ? void 0 : redirectLink}
                        src={resourceLink}
                        width={windowWidth}
                        height={windowHeight}
                        background={false}
                        fixed
                    />
                </Tracker>
                <button
                    className={cn(styles['btn-close'], 'btn-no-style')}
                    onClick={handleClose}
                >
                    <Iconfont className="icon-x"/>
                </button>
            </FixedContainer>
        );
};

export default observer(FloatMiniEntrance);
